<template>
  <div class="user-organizations">
    <organization-tile
      :loading="loading"
      v-for="organization in organizations"
      :key="organization.id"
      :organization="organization"
      @cancelMembership="cancelMembership"
      @acceptMembership="acceptMembership" />
    <div class="no-organizations" v-if="organizations.length === 0">
      <h1>You are not member of any organizations</h1>
      <el-button type="primary" @click="$emit('goBrowse')">Browse organizations</el-button>
    </div>
  </div>
</template>

<script>
import OrganizationTile from './OrganizationTile'

export default {
  name: 'UserOrganizations',
  components: { OrganizationTile },
  props: {
    organizations: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {},
  methods: {
    async acceptMembership (organization) {
      this.loading = true
      const data = { pending: false, invite: false }
      const response = await this.$http.put(this.$api.organizations.users.update(organization.id, this.$auth.user.id, true), data)
      this.$emit('acceptMembershipSuccess', organization, true, false, false)
      this.loading = false
    },
    async cancelMembership (organization) {
      this.loading = true
      const response = await this.$http.delete(this.$api.organizations.users.delete(organization.id, this.$auth.user.id))
      this.$emit('cancelMembershipSuccess', organization, false, false ,false)
      this.$message.success('Membership request cancelled')
      this.loading = false
    }
  },
  created () {}
}
</script>

<style lang="scss" scoped>
  .no-organizations {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;

    h1 {
      text-align: center;
      width: 100%;
      margin-top: 100px;
      font-size: 24px;
      color: $text-light;
    }
  }

  .user-organizations {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-left: -0.66%;
    margin-right: -0.66%;

    @include breakpoint (xs) {
      margin: 0px 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/user/UserOrganizations.vue